import React from "react";
import { Phone, HelpCircle } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "components/shadcn/accordion";
import { faqItems } from "./lib/faq";
import { SUPPORT_EMAIL } from "../../utils/support";


/**
 * Support Page
 * ------------
 * Support page is currently not implemented, but should serve as place here:
 * - Users can find contact information for suppport
 * - Shows FAQ for the distributor dashboard
 */

export const SupportPage: React.FC = () => {

  return (
    <div className="flex flex-col gap-8">
      {/* FAQ Section */}
      <div className="">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-blue-50 text-blue-600">
            <HelpCircle className="w-7 h-7" aria-hidden="true" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Frequently Asked Questions
            </h3>
            <p className="text-sm text-gray-600">
              Find answers to common questions about your distributor dashboard
            </p>
          </div>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqItems.map((faqItem) => (
            <AccordionItem key={faqItem.id} value={faqItem.id}>
              <AccordionTrigger className="text-left">
                {faqItem.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600">
                {faqItem.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      <div className="flex gap-8">
        <div className="flex flex-col h-full bg-white border border-gray-200 rounded-xl p-6 transition-shadow hover:shadow-md focus-within:shadow-md outline-none">
          <div className="w-12 h-12 flex items-center justify-center rounded-lg mb-4 bg-green-50 text-green-600">
            <Phone className="w-7 h-7" aria-hidden="true" />
          </div>
          <h3 className="text-lg font-semibold mb-2 text-gray-900">
            Contact Support
          </h3>
          <div className="flex flex-col gap-2">
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="text-sm font-semibold text-blue-700 underline underline-offset-2 hover:text-blue-900 focus:text-blue-900 focus:outline-none mt-4"
              aria-label={`Email ${SUPPORT_EMAIL}`}
              tabIndex={0}
            >
              {SUPPORT_EMAIL}
            </a>
            <a
              href="tel:+4593909950"
              className="text-sm font-semibold text-blue-700 underline underline-offset-2 hover:text-blue-900 focus:text-blue-900 focus:outline-none"
              aria-label="Call +45 93 90 99 50"
              tabIndex={0}
            >
              +45 93 90 99 50
            </a>
            <span className="text-xs text-gray-500 mt-3">
              Available Mon-Fri, 9:00-14:00 CET
            </span>
          </div>
        </div>

      </div>




    </div>
  );
};
